import Component from 'core/Component';
import { Event } from 'services/EventEmitter';
import { on, off } from 'toolbox/event';
import { deepMerge } from 'toolbox/deepMerge';

/**
 * This is a description of the RefinementsToggler constructor function.
 * @class
 * @classdesc This is a description of the RefinementsToggler class.
 * @extends Component
 */
export default class RefinementsToggler extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     *
     * @param {HTMLElement} element HTMLElement of the component
     * @param {Object} options That belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            events: {
                apply: 'search.refinements.apply',
                updated: 'search.updated',
                toggle: 'search.refinementsPanel.toggle',
            },
        }, options));
    }

    /**
     * All selectors must be cached. Never cache elements that are out of the component scope
     */
    initCache() {
        this.selectors.qty = this.element.querySelector('[data-js-qty]');
        this.selectors.button = this.element.querySelector('[data-js-button]');
        this.selectors.appliedRefinementsList = this.element.querySelector('[data-js-applied-refinements-list]');
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonymous function
     */
    bindEvents() {
        on('click.refinementsToggler', this.element, this.onClick.bind(this));
        Event.on(this.options.events.apply, this.onRefinementsApply, this);
        Event.on(this.options.events.updated, this.onSearchUpdated, this);
    }

    /**
     * Click event handler
     */
    onClick() {
        Event.emit(this.options.events.toggle);
    }

    /**
     * Refinements Apply event handler
     *
     * @param {Object} e Event object
     */
    onRefinementsApply(e) {
        if (!e.dontUpdateURL) {
            this.updateFiltersQuantity(e.appliedFiltersQty);
        }
    }

    /**
     * Search Updated event handler
     *
     * @param {Object} data Data due to refinement to be changed
     * @param {Boolean} isInsertMode Flag due to a insertion
     */
    onSearchUpdated(data, isInsertMode) {
        const dataModel = this.options.dataModelId ? data[this.options.dataModelId] : data.refinementsbutton;
        if (dataModel && !isInsertMode && !dataModel.suppressRender) {
            this.updateFiltersQuantity(dataModel.appliedRefinements);
            if (this.selectors.appliedRefinementsList) {
                this.selectors.appliedRefinementsList.innerHTML = dataModel.appliedRefinementsList;
            }
        }
    }

    /**
     * Update Filters Quantity
     *
     * @param {Number} quantity of filters
     */
    updateFiltersQuantity(quantity) {
        const appliedFiltersClass = 'm-filters-applied';
        this.selectors.qty.innerHTML = quantity || '';
        this.selectors.button.classList.toggle(appliedFiltersClass, quantity > 0);
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        off('click.refinementsToggler', this.element);
        Event.removeListener(this.options.events.apply, this.onRefinementsApply, this);
        Event.removeListener(this.options.events.updated, this.onSearchUpdated, this);
    }
}
